import { render } from "./Sidebar.vue?vue&type=template&id=5aafa487"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=5aafa487&lang=scss"

import exportComponent from "C:\\Users\\Fede Itti\\vue\\elantiguo_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__